import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import sacPoubelleImage from "@/assets/products/sac-poubelle.png";

const config: ProductPageConfig = {
  name: "Sacs poubelle 130L",
  breadcrumbName: "Sacs poubelle",
  subtitle: "Sacs poubelle résistants en rouleau de 25 sacs",
  features: ["Résistant", "130 litres", "Disponible en stock"],
  variants: [
    { name: "Sac poubelle 130L", capacity: "130 litres", material: "Plastique", packaging: "Carton de 100 (4 rouleaux x 25)", palette: "90 cartons", image: sacPoubelleImage },
  ],
};

const SacPoubelle = () => <ProductPageLayout config={config} />;
export default SacPoubelle;
